export default {
  setMigrationDialogHeader: 'Nastaviť začiatok migrácie',
  setMessage: 'Naozaj chcete resetovať stav migrácie pre {count} {type}?\nV dôsledku toho budú všetky {type} migrované od {date}.',
  setMigrationDialogErrorPast: 'Dátum musí byť v minulosti',
};
